export const GET_CLINIC_FOLLOW_UP_APPOINTMENTS =
  "clinic/get-all-follow-up-appointments";

export const GET_ALL_NEW_LEADS = "clinic/get-all-new-leads";
export const UPDATE_FOLLOWUP_STATUS = "clinic/update-follow-up-status";
export const UPDATE_NEW_LEAD_STATUS = "clinic/update-lead-status";
export const DOCTOR_CALL_PATIENT_API = "/doctor/doctor-call-patient";
export const RESCHEDULE_LEAD = "clinic/reschdule-lead";
export const VIEW_LEAD_DETAILS = "doctor/get-appointment-details-by-id";

export const GET_CLINIC_LIST_FOR_DOCTOR = "clinic/get-all-clinic-list";
export const GET_CLINIC_LIST_FOR_STAFF = "clinic/get-all-clinic-list-staff";
export const GET_CLINIC_PATIENT_LIST = "/clinic/get-own-patient";
export const GET_STATE_AND_CITY = "/public/get-city";
export const ADD_EDIT_LEAD = "/clinic/add-edit-leads";
export const GET_DOCTOR_RESOURCE_LIST = (clinic_id) => {
  return `clinic/v1/clinics/${clinic_id}/doctor_resource_procedures`;
};
export const ADD_REMARK_API = "/clinic/add-edit-leads-remarks";
export const GET_REMARK_API = "/clinic/get-leads-remarks";
export const DELETE_REMARK_API = (id) => `/clinic/delete-leads-remarks/${id}`;
export const GET_VIEW_LEAD_DETAILS = "doctor/get-appointment-details-by-id";
export const GET_LEAD_DETAILS = "clinic/get-lead-details";
export const UPDATE_QUOTE = "clinic/update-quote";
export const GET_FOLLOW_UP_APPOINTMENT_DETAILS =
  "/clinic/get-patient-appointments-list";
export const GET_DOCTOR_LIST = "clinic/get-clinic-doctors";
export const DOWNLOAD_FOLLOW_UP_NEW_LEAD =
  "/clinic/download-report/follow-up-new-leads";
export const GET_LEAD_FOLLOWUP_LOGS_API = "/clinic/get-lead-followup-logs";
export const GET_FOLLOWUP_DOCTOR_PROCEDURE_API =
  "clinic/get-follow-up-doctor-procedure-list";
export const SEND_MESSAGE = "/clinic/send-quote";
export const GET_QUOTATION_URL = "/clinic/get-follow-up-lead-pdf-url";
export const GET_QUOTE_PDF = "clinic/get-follow-up-lead-pdf-url";

// campaign APU
export const GET_ACCOUNTS_LIST = "clinic/get-facebook-accounts-list";
export const GET_CAMPAIGN_LIST = "/clinic/get-campaign-list";
export const GET_CONTACTS_LIST = "/clinic/get-clinic-campaign-contacts";
